import React, { useState } from "react";
import CustomButton from "../../Components/Button";
import { isValidEmail, showToast } from "../../utils/helpers";
import { API } from "../../utils/Apis";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router";

interface ForgotPasswordType {
  type?: "inline" | "modal";
  changeForm?: Function;
}

const ForgotPassword: React.FC<ForgotPasswordType> = ({
  changeForm = null,
}) => {
  const [reSending, setResending] = useState(false);
  const [loading, setLoading] = useState(false);
  const [step, setActiveStep] = useState("Email");

  const [data, setData] = useState({
    email: "",
    password: "",
    cpassword: "",
    otp: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    otp: "",
    password: "",
    cpassword: "",
  });

  const onChange = (name: string, value: string) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const validate = () => {
    let isErr = false;
    const errors = {
      email: "",
      otp: "",
      password: "",
      cpassword: "",
    };

    if (step == "Email" && (!data.email || data.email === "")) {
      isErr = true;
      errors.email = "Please enter you email";
    } else if (step == "Email" && data.email && !isValidEmail(data.email)) {
      isErr = true;
      errors.email = "Please enter your valid email";
    }

    if (step == "Verify" && (!data.otp || data.otp === "")) {
      isErr = true;
      errors.otp = "Please enter verification code";
    } else if (step == "Verify" && data.otp.length !== 6) {
      isErr = true;
      errors.otp = "Please enter valid verification code";
    }

    if (step == "UpdatePassword" && (!data.password || data.password === "")) {
      isErr = true;
      errors.password = "Please enter new pasword";
    }
    if (
      step == "UpdatePassword" &&
      (!data.cpassword || data.cpassword === "")
    ) {
      isErr = true;
      errors.password = "Please confirm your pasword";
    } else if (step == "UpdatePassword" && data.password !== data.cpassword) {
      isErr = true;
      errors.cpassword =
        "Please confirm password didn't match with your password";
    }

    setErrors(errors);

    return isErr;
  };

  const submitForm = () => {
    const isErr = validate();

    if (!loading && !isErr) {
      if (step === "Email") {
        setLoading(true);

        API.forgotRequest({ email: data.email })
          .then((res) => {
            if (res.type === "success") {
              setActiveStep("Verify");
            } else {
              showToast("error", res.message);
            }
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setLoading(false));
      } else if (step === "Verify") {
        setLoading(true);

        API.verifyForgotRequest({ email: data.email, otp: data.otp })
          .then((res) => {
            if (res.type === "success") {
              setActiveStep("UpdatePassword");
            } else {
              showToast("error", res.message);
            }
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setLoading(false));
      } else if (step === "UpdatePassword") {
        setLoading(true);

        API.updatePassword({
          email: data.email,
          otp: data.otp,
          password: data.password,
          cpassword: data.cpassword,
        })
          .then((res) => {
            if (res.type === "success") {
              if (changeForm) {
                changeForm("Login");
              }

              setActiveStep("UpdatePassword");
            } else {
              showToast("error", res.message);
            }
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setLoading(false));
      }
    }
  };

  const resendOtpCode = () => {
    if (!reSending) {
      setResending(true);

      API.resendForgotOtp({ email: data.email })
        .then((res) => {
          if (res.type === "success") {
          } else {
            showToast("error", res.message);
          }
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() => setResending(false));
    }
  };

  return (
    <div className="auth-form-wrapper">
      <div className="auth-headings">
        <div className="d-flex align-items-center">
          <div className="text-center w-100">
            <h3>Forgot Password</h3>
            <p>Recover your password</p>
          </div>
        </div>
      </div>

      <div className="auth-form">
        {step !== "Email" && (
          <div className="text-left mb-3 mr-1">
            <span
              className="p-1 pl-0 flex align-items-center"
              onClick={() =>
                setActiveStep(step == "UpdatePassword" ? "Verify" : "Email")
              }
            >
              <FontAwesomeIcon icon={faChevronLeft} /> Back
            </span>
          </div>
        )}

        {step === "Email" && (
          <div className="form-group">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Enter your email"
              value={data.email}
              onChange={(e) => onChange("email", e.target.value)}
            />
            {errors.email && errors.email !== "" && (
              <span className="error">{errors.email}</span>
            )}
          </div>
        )}

        {step === "Verify" && (
          <>
            <div className="form-group">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter your email"
                value={data.email}
                disabled
                // onChange={(e) => onChange("email", e.target.value)}
              />
              {errors.email && errors.email !== "" && (
                <span className="error">{errors.email}</span>
              )}
            </div>

            <div className="form-group">
              <input
                type="text"
                name="otp"
                className="form-control"
                placeholder="Enter Verification Code"
                value={data.otp}
                onChange={(e) => onChange("otp", e.target.value)}
              />
              {errors.otp && errors.otp !== "" && (
                <span className="error">{errors.otp}</span>
              )}
            </div>
          </>
        )}

        {step === "UpdatePassword" && (
          <>
            <div className="form-group">
              <input
                type="password"
                name="password"
                className="form-control"
                placeholder="Enter your new password"
                value={data.email}
                disabled
                // onChange={(e) => onChange("email", e.target.value)}
              />
              {errors.password && errors.password !== "" && (
                <span className="error">{errors.password}</span>
              )}
            </div>

            <div className="form-group">
              <input
                type="password"
                name="cpassword"
                className="form-control"
                placeholder="Confirm your password"
                value={data.cpassword}
                onChange={(e) => onChange("cpassword", e.target.value)}
              />
              {errors.cpassword && errors.cpassword !== "" && (
                <span className="error">{errors.cpassword}</span>
              )}
            </div>
          </>
        )}

        <CustomButton
          title="Verify"
          isLoading={loading}
          onClick={() => submitForm()}
        />

        <div className="have-an-account-links">
          <p>
            Already have an account?{" "}
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                if (changeForm) {
                  changeForm("Login");
                }
              }}
            >
              Login
            </Link>
          </p>
        </div>

        {step === "Verify" && (
          <span className="p-2 text-center info-text">
            Didn't receive verification code?{" "}
            <span
              className="forgot-link as-link mt-0"
              onClick={() => resendOtpCode()}
            >
              {" "}
              {reSending && <FontAwesomeIcon icon={faSpinner} spin />}
              {!reSending && "Resend it"}
            </span>
          </span>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
